import "./../../styles/SessionExpiredPopup.css";

const SessionExpiredPopup = ({ onConfirm, header = "You are Logged Out", title = "Your session has expired.", subtitle = "You will be redirected to the Login page." }) => {
  return (
    <div className="session-expired-overlay">
      <div className="session-expired-card">
        <div className="session-expired-header">{header}</div>
        <div className="session-expired-body">
          <p className="session-expired-title">{title}</p>
          <p className="session-expired-subtitle">{subtitle}</p>
        </div>
        <button type="button" className="session-expired-ok-button" onClick={onConfirm}>
          OK
        </button>
      </div>
    </div>
  );
};

export default SessionExpiredPopup;
